<ng-container [ngSwitch]="type">
  <ng-container *ngSwitchCase="'investigation'">
    <div class="merged-column-cell">
      <ng-container>
        <div class="nefco-number merged-column-highlight">
          <a target="_blank" [routerLink]="['/investigations/', dataItem?.id]" tel=""
            class="text-decoration merged-column-highlight">
            {{ dataItem?.nefcoNumber || 'Unassigned' }}
          </a>
          <ng-container *ngIf="dataItem?.DraftStatusReport">
            <app-status-variant-icon variant="error" iconClass="fa fa-exclamation-triangle"
              tooltipTitle="This investigation has one or more reports in “Drafts”. Please complete the report(s)."></app-status-variant-icon>
          </ng-container>
        </div>
      </ng-container>

      <ng-container>
        <ng-container *ngIf="dataItem?.InvestigationAddress?.id; else lossAddressTpl">
          <ng-container *ngIf="dataItem?.InvestigationAddress?.address1">
            <span>{{ dataItem?.InvestigationAddress?.address1 }}<br /></span>
          </ng-container>

          <ng-container *ngIf="dataItem?.InvestigationAddress?.address2">
            <span>{{ dataItem?.InvestigationAddress?.address2 }}<br /></span>
          </ng-container>

          <ng-container *ngIf="dataItem?.InvestigationAddress?.address3">
            <span>{{ dataItem?.InvestigationAddress?.address3 }}<br /></span>
          </ng-container>

          <span>
            {{ dataItem?.InvestigationAddress?.city ? dataItem?.InvestigationAddress?.city + ',' : '' }}
            {{ dataItem?.InvestigationAddress?.state }}
            {{ dataItem?.InvestigationAddress?.postal }}
          </span>
        </ng-container>

        <ng-template #lossAddressTpl>
          <ng-container *ngIf="dataItem?.LossAddress?.address1">
            <span>{{ dataItem?.LossAddress?.address1 }}<br /></span>
          </ng-container>

          <ng-container *ngIf="dataItem?.LossAddress?.address2">
            <span>{{ dataItem?.LossAddress?.address2 }}<br /></span>
          </ng-container>

          <ng-container *ngIf="dataItem?.LossAddress?.address3">
            <span>{{ dataItem?.LossAddress?.address3 }}<br /></span>
          </ng-container>

          <span>
            {{ dataItem?.LossAddress?.city ? dataItem?.LossAddress?.city + ',' : '' }}
            {{ dataItem?.LossAddress?.state }}
            {{ dataItem?.LossAddress?.postal }}
          </span>
        </ng-template>

        <p kendoTooltip position="bottom" title="Investigation Created" tooltipClass="tooltipwidthauto"
          class="merged-column-created-date mb-0">
          {{ dataItem?.createdAt | customDate : ('MM/dd/yyyy') : true }}&nbsp;<i
            class="fa-solid fa-question-circle"></i>
        </p>
        <br />
      </ng-container>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'details'">
    <div class="merged-column-cell">
      <ng-container>
        <div class="risk-type merged-column-highlight" *ngIf="dataItem?.RiskType?.name">
          <img class="risk-type-img" [src]="getIcon(dataItem?.RiskType?.name)" />
          <span class="text-overflow">{{ dataItem?.RiskType?.name }}</span>
        </div>
      </ng-container>
      <ng-container>
        <span>{{ dataItem?.lossDate | customDate : 'MM/dd/yyyy' : true }}</span>
        <br />
      </ng-container>
      <ng-container>
        <ng-container
          *ngIf="!dataItem?.Client?.firstName && !dataItem?.Client?.lastName && !dataItem?.ClientBranch; else detailsClientInfo">-</ng-container>
        <ng-template #detailsClientInfo>
          <span *ngIf="dataItem?.Client">
            <app-client-info-popover [id]="dataItem?.id" [client]="dataItem?.Client"></app-client-info-popover>
            <br />
          </span>
          <span *ngIf="dataItem?.ClientBranch?.Company?.name">{{ dataItem?.ClientBranch?.Company?.name }}<br /></span>
        </ng-template>
      </ng-container>

      <ng-container>
        <span>{{ dataItem?.Insured | insuredName }}<br /></span>
        <span class="phone-number" *ngIf="dataItem?.Insured?.Phones?.length">
          <a [href]="'tel:' + ((dataItem?.Insured?.Phones | primaryAssociation)?.number || '')">
            {{ (dataItem?.Insured?.Phones | primaryAssociation)?.number | phoneFormat : 'US' }}
          </a><br />
        </span>
      </ng-container>

      <ng-container>
        <span>P#:</span> {{ dataItem?.Detail?.policyNumber || '-' }}<br />
        <span>C#:</span> {{ dataItem?.Detail?.claimNumber || '-' }}
      </ng-container>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'priority'">
    <img *ngIf="dataItem?.Priority?.name" [src]="getPriorityIcon(dataItem?.Priority?.name)"
      [title]="getPriorityTooltip(dataItem?.Priority?.name)" kendoTooltip tooltipClass="tooltipwidthauto"
      position="bottom" />
    <ng-container *ngIf="!dataItem?.Priority?.name">-</ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="'current'">
    <div class="investigation-icons-column">
      <i class="fa-solid fa-comment-dots color-dark-blue cursor-pointer" kendoTooltip position="bottom"
        title="Add comments" tooltipClass="tooltipwidthauto" *ngIf="investigationCommentsCreateEnabled"
        (click)="onAddComment()"></i>

      <i class="fa-solid fa-money-bill color-money cursor-pointer" kendoTooltip position="bottom"
        title="Billable entries have not been sent to client" *ngIf="dataItem?.UnBilledEntries > 0"
        tooltipClass="tooltipwidthauto" (click)="navigateTo('expenses')"></i>

      <i class="fa-solid fa-circle-minus color-danger" kendoTooltip position="bottom" title="Marked to Close"
        *ngIf="dataItem?.InvestigationMarkClose?.[0]?.markClosed === true" tooltipClass="tooltipwidthauto"></i>

      <i class="fa-solid fa-hourglass-half color-dark-blue" kendoTooltip position="bottom"
        *ngIf="dataItem?.Detail?.waitingForDocusketch" title="Waiting for Docusketch"
        tooltipClass="tooltipwidthauto"></i>

      <i class="fa-solid fa-user-tie" kendoTooltip position="bottom" title="Client Review"
        *ngIf="dataItem?.ClientReview" tooltipClass="tooltipwidthauto"></i>

      <app-svg-icon name="book-blank" [size]="20" variant="success" kendoTooltip position="bottom"
        title="Billable Hours" *ngIf="dataItem?.TimeDairyIcon === 'GREEN'" tooltipClass="tooltipwidthauto"
        class="cursor-pointer" (click)="navigateTo('expenses')"></app-svg-icon>

      <app-svg-icon name="book-blank" [size]="20" variant="secondary" kendoTooltip position="bottom" title="Diary"
        *ngIf="dataItem?.TimeDairyIcon === 'BROWN'" tooltipClass="tooltipwidthauto" class="cursor-pointer"
        (click)="navigateTo('expenses', 'invoiced-entries')"></app-svg-icon>

      <i class="fa-solid fa-folder color-folder cursor-pointer" kendoTooltip position="bottom" title="Document Uploaded"
        *ngIf="dataItem?.DocumentUploaded" tooltipClass="tooltipwidthauto"
        (click)="navigateTo('documents', 'uploads')"></i>

      <app-svg-icon name="mailbox-documents-sent" *ngIf="dataItem?.DocumentSent" [size]="20" variant="primary-green"
        kendoTooltip position="bottom" title="Document Sent" tooltipClass="tooltipwidthauto" class="cursor-pointer"
        (click)="navigateTo('documents', 'shared-reports')"></app-svg-icon>

      <i class="fa-solid fa-dolly color-dolly cursor-pointer" *ngIf="dataItem?.EvidenceUploaded" kendoTooltip
        position="bottom" title="Evidence Uploaded" tooltipClass="tooltipwidthauto"
        (click)="navigateTo('evidence')"></i>

      <i class="fa-solid fa-image color-dark-blue cursor-pointer" kendoTooltip position="bottom" title="Photos Uploaded"
        *ngIf="dataItem?.PhotosUploaded" tooltipClass="tooltipwidthauto" (click)="navigateTo('photos')"></i>

      <i class="fa-solid fa-calendar-days color-dark-blue cursor-pointer" kendoTooltip position="bottom"
        title="Event Scheduled" *ngIf="dataItem?.PastEvents" tooltipClass="tooltipwidthauto"
        (click)="navigateTo('details', 'on-scene-dates')"></i>

      <ng-container *ngFor="let report of dataItem?.ReportsWithStatus">
        <app-svg-icon *ngIf="getReportIconName(report) as reportIconName" [name]="reportIconName" [size]="20"
          [variant]="getReportIconVariant(report)" kendoTooltip position="bottom" [title]="
            (getReportTypeLabel(report) || 'Report') +
            ' - ' +
            getReportStatusLabel(report) +
            ' - ' +
            ((report?.latestSnapshot?.createdAt | customDate : 'MM/dd/yyyy') || '-')
          " tooltipClass="tooltipwidthauto" class="cursor-pointer" (click)="onOpenReports($event)"></app-svg-icon>
      </ng-container>
    </div>
  </ng-container>
</ng-container>
